import { BookOpen, CalendarRange, Clock } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

/**
 * Die drei Bereiche. Ein vierter Tab "Tools" ist in Stufe 1 ausdruecklich
 * nicht vorgesehen - siehe "Was in Stufe 1 bewusst fehlt" im README.
 */
export const TABS = ['fristen', 'jahresplan', 'glossar'] as const;
export type TabId = (typeof TABS)[number];

export const TAB_TITEL: Record<TabId, string> = {
  fristen: 'Fristen',
  jahresplan: 'Jahresplan',
  glossar: 'Glossar',
};

const SYMBOL: Record<TabId, LucideIcon> = {
  fristen: Clock,
  jahresplan: CalendarRange,
  glossar: BookOpen,
};

/**
 * Untere Navigationsleiste (Design A). Fest am unteren Bildschirmrand, damit
 * sie mit einer Hand erreichbar bleibt - der Hauptgrund fuer die Umstellung
 * von der frueheren Reiterleiste oben.
 */
export function TabLeiste({
  aktiv,
  wechsle,
}: {
  aktiv: TabId;
  wechsle: (tab: TabId) => void;
}) {
  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-10 border-t border-marke-linie bg-white pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-2"
      aria-label="Bereiche"
    >
      <div className="mx-auto flex max-w-5xl px-2">
        {TABS.map((id) => {
          const Symbol = SYMBOL[id];
          const istAktiv = aktiv === id;
          return (
            <button
              key={id}
              type="button"
              onClick={() => {
                wechsle(id);
              }}
              aria-current={istAktiv ? 'page' : undefined}
              className={`flex flex-1 flex-col items-center gap-1 rounded-xl py-1.5 transition-colors ${
                istAktiv ? 'text-marke-blau' : 'text-marke-grau'
              }`}
              style={{ minHeight: 56 }}
            >
              <Symbol size={23} aria-hidden="true" />
              <span className="text-xs font-semibold">{TAB_TITEL[id]}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
